module.exports = __webpack_public_path__ + "media/43.b7bdb518.mp3";